import { Box, useMediaQuery, useTheme } from '@mui/material'
import { AnimatePresence, motion } from 'framer-motion'
import { useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import { Sidebar, SIDEBAR_WIDTH } from '@/layouts/components/Sidebar'
import { Topbar } from '@/layouts/components/Topbar'
import { CONTENT_PADDING } from '@/theme/layout'

export function AppLayout() {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))
  const [mobileOpen, setMobileOpen] = useState(false)
  const location = useLocation()

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar
        variant={isDesktop ? 'permanent' : 'temporary'}
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
      />

      <Box
        component="main"
        sx={{
          flex: 1,
          minWidth: 0,
          ml: isDesktop ? `${SIDEBAR_WIDTH}px` : 0,
        }}
      >
        <Topbar onMenuClick={() => setMobileOpen(true)} />

        <Box sx={{ p: CONTENT_PADDING }}>
          <AnimatePresence mode="wait">
            <motion.div
              key={location.pathname}
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -8 }}
              transition={{ duration: 0.18, ease: 'easeOut' }}
            >
              <Outlet />
            </motion.div>
          </AnimatePresence>
        </Box>
      </Box>
    </Box>
  )
}
